import React from 'react'
import '../styles/IEInfoStyle.css'
import {
  chromeDownloadURL,
  mozillaDownloadURL,
  operaDownloadURL,
  edgeDownloadURL,
  biezacyRok,
  politykaPrywatnosciURL,
} from '../lib/consts'

const IEInfo = () => (
  <div className="ie-alert">
    <div className="ie-alert-container">
      <header className="ie-alert-header">
        <div className="ie-alert-raks" />
      </header>
      <section className="ie-alert-section">
        <p className="ie-alert-error" />
        <p className="ie-alert-p">
          Naszą aplikację tworzymy korzystając z najnowszych technologii, tak
          aby była coraz lepsza i wydajniejsza. Niestety Twoja przeglądarka nie
          wspiera tych technologii.
        </p>
        <p className="ie-alert-p">
          Pobierz najnowszą wersję jednej z poniższych przeglądarek, aby
          skorzystać z naszej aplikacji.
        </p>

        <div className="ie-alert-linkList">
          <a
            className="ie-alert-a"
            title="Przejdź do pobrania przeglądarki Google Chrome"
            href={chromeDownloadURL}
          >
            <div className="ie-alert-browser-img chrome" alt="Google Chrome" />
            <div className="ie-alert-browser-name">Google Chrome</div>
            <div className="ie-alert-browser-link">POBIERZ</div>
          </a>
          <a
            className="ie-alert-a"
            title="Przejdź do pobrania przeglądarki Mozilla Firefox"
            href={mozillaDownloadURL}
          >
            <div
              className="ie-alert-browser-img firefox"
              alt="Mozilla Firefox"
            />
            <div className="ie-alert-browser-name">Mozilla Firefox</div>
            <div className="ie-alert-browser-link">POBIERZ</div>
          </a>
          <a
            className="ie-alert-a"
            title="Przejdź do pobrania przeglądarki Opera"
            href={operaDownloadURL}
          >
            <div className="ie-alert-browser-img opera" alt="Opera" />
            <div className="ie-alert-browser-name">Opera</div>
            <div className="ie-alert-browser-link">POBIERZ</div>
          </a>
          <a
            className="ie-alert-a"
            title="Przejdź do pobrania przeglądarki Microsoft Edge"
            href={edgeDownloadURL}
          >
            <div className="ie-alert-browser-img edge" alt="Microsoft Edge" />
            <div className="ie-alert-browser-name">Microsoft Edge</div>
            <div className="ie-alert-browser-link">POBIERZ</div>
          </a>
        </div>
      </section>
    </div>
    <footer class="ie-alert-footer">
      <div className="ie-alert-copyright">
        <p>© {biezacyRok} RAKS Spółka z o.o. wszystkie prawa zastrzeżone.</p>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={politykaPrywatnosciURL}
        >
          Polityka prywatności
        </a>
      </div>
    </footer>
  </div>
)

export default IEInfo
